function Config() {
    return { 
        url: 'https://promo-api.drivesocial.io',
        promoId: "aprovec"
    }
}
export default Config